import { RouteFunctionParams, TileRoleRoute } from '@/types'
import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { defer, LoaderFunction } from 'react-router-typesafe'
import CostCenterRationale from '@/routes/admin/users/costcenterrationale/CostCenterRationale'

export const costCenterRationaleLoader = (async ({ request, params }: RouteFunctionParams) => {
  const qsAdminApi = useQsAdminApiManager.getState().service

  const getCentriCosto = qsAdminApi.centro_costo().query((builder, centroCosto) => {
    builder.select('id', 'nome')
    builder.orderBy(centroCosto.nome.asc())
  })

  return defer({ title: 'Editazione causali centro di costo', getCentriCosto })
}) satisfies LoaderFunction

export const CostCenterRationaleRoute: TileRoleRoute = {
  path: 'causalecentrocosto',
  text: 'Causale Centro Costo',
  loader: costCenterRationaleLoader,
  faIcon: faChalkboardTeacher,
  element: <CostCenterRationale />,
  handle: {
    crumb: () => ({
      label: 'Causale Centro Costo',
      icon: faChalkboardTeacher,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
}
